import React, { useState } from 'react';
import PropTypes from 'prop-types';
import moment from 'moment';
import { useTranslation } from 'react-i18next';
import { useLocation } from 'react-router-dom';

import { Typography, Link } from '@material-ui/core';
import { makeStyles } from '@material-ui/styles';
import useMediaQuery from '@material-ui/core/useMediaQuery';

import TermsDialog from './TermsDialog';

const useStyles = makeStyles((theme) => ({
  footer: {
    bottom: 5,
    right: theme.spacing(4),
    position: 'fixed',
    display: 'block',
    zIndex: 1500,
    backgroundColor: 'white',
    padding: 5,
    borderRadius: 50,
  },
  a: {
    textDecoration: 'none',
    backgroundColor: 'transparent',
    ...theme.defaultFont,
    color: theme.palette.text.primary,
  },
  aWhite: {
    textDecoration: 'none',
    backgroundColor: 'transparent',
    ...theme.defaultFont,
    color: 'white',
  },
}));

const Footer = ({ ...props }) => {
  const { t } = useTranslation();
  const location = useLocation();
  const matchesSmall = useMediaQuery((theme) => theme.breakpoints.down('sm'));
  const classes = useStyles();
  const year = moment().format('YYYY');

  const [openTermsDialog, setOpenTermsDialog] = useState(false);
  const [showPrivacy, setShowPrivacy] = useState(false);

  const setShowPrivacyTerms = (openTerms, privacy) => {
    setShowPrivacy(openTerms && privacy);
    setOpenTermsDialog(openTerms);
  };

  if (matchesSmall && location && location.pathname !== '/') {
    return <div />;
  }

  return (
    <footer className={classes.footer}>
      <Typography className={classes.terms} style={props.white ? { fontColor: 'white' } : {}}>
        <span className={props.white ? classes.aWhite : classes.a} style={{ paddingRight: 20 }}>
          &copy; {year}{' '}
          <a href={t('brand_url')} className={props.white ? classes.aWhite : classes.a}>
            {t('brand')}
          </a>
        </span>
        <Link
          className={classes.link}
          style={props.white ? { color: 'white' } : {}}
          onClick={() => setShowPrivacyTerms(true, false)}
        >
          {t('terms_of_service')}
        </Link>
        <span style={{ padding: 5 }} />
        <Link
          className={classes.link}
          style={props.white ? { color: 'white' } : {}}
          onClick={() => setShowPrivacyTerms(true, true)}
        >
          {t('terms_privacy_policy')}
        </Link>
        {openTermsDialog && (
          <TermsDialog privacyPolicy={showPrivacy} open handleClose={() => setOpenTermsDialog(false)} />
        )}
      </Typography>
    </footer>
  );
};

Footer.propTypes = {
  white: PropTypes.bool,
};

Footer.defaultProps = {
  white: false,
};

export default Footer;
